import { render, staticRenderFns } from "./FieldDetailsPanel.vue?vue&type=template&id=b5ffeb9e&scoped=true&lang=html&"
import script from "./FieldDetailsPanel.vue?vue&type=script&lang=js&"
export * from "./FieldDetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./FieldDetailsPanel.vue?vue&type=style&index=0&id=b5ffeb9e&lang=scss&scoped=true&"
import style1 from "./FieldDetailsPanel.vue?vue&type=style&index=1&id=b5ffeb9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ffeb9e",
  null
  
)

export default component.exports